<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{task}} Price Matrix {{task === 'Edit' ? ' (ID: ' + data.pmInputData?.id + ')' : ''}}
  </div>
  <button mat-icon-button class="close-btn" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="priceMatrixForm" class="form-grid">
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Disposal Site</mat-label>
        <mat-select multiple formControlName="disposalSitesIds" placeholder="Select Disposal Site(s)">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #siteSearchInput matInput placeholder="Search Disposal Site..." (input)="filterDisposalSites($event)"
              class="mat-select-search-input" aria-label="Search Disposal Site" (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          <mat-option *ngFor="let site of filtereddisposalSites()" [value]="site.sid">
            {{ site.siteName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="priceMatrixForm.get('disposalSitesIds')?.hasError('required')">
          Disposal Site is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Tip Fee + UOM -->
      <mat-form-field appearance="outline">
        <mat-label>Tip Fee</mat-label>
        <input matInput type="text" data-testId="tipFee" formControlName="tipFee"
          (input)="roundOff($event, 99999, 4, 0, 'tipFee')" />
        <mat-error *ngIf="priceMatrixForm.get('tipFee')?.hasError('required')">
          Tip Fee is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Tip Fee UOM</mat-label>
        <mat-select formControlName="tipFee_UOM">
          <mat-option *ngFor="let o of tipFeeUOM()" [value]="o.id">{{ o.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="priceMatrixForm.get('tipFee_UOM')?.hasError('required')">
          Tip Fee UOM is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Rental / Haul -->
      <!-- <mat-form-field appearance="outline">
        <mat-label>Rental Rate</mat-label>
        <input matInput type="text" data-testId="rentalRate" formControlName="rentalRate"
          (input)="roundOff($event, 9999, 4, 0, 'rentalRate')" />
      </mat-form-field> -->
      <mat-form-field appearance="outline">
        <mat-label>Haul Revenue</mat-label>
        <input matInput type="text" data-testId="haulRevenue" formControlName="haulRevenue"
          (input)="roundOff($event, 9999, 4, 0, 'haulRevenue')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Extra fields -->
      <mat-form-field appearance="outline">
        <mat-label>Monthly Charges</mat-label>
        <input matInput type="text" data-testId="monthlyCharges" formControlName="monthlyCharges"
          (input)="roundOff($event, 9999, 4, 0, 'monthlyCharges')" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Extra Pickup</mat-label>
        <input matInput type="text" data-testId="extraPickup" formControlName="extraPickup"
          (input)="roundOff($event, 9999, 4, 0, 'extraPickup')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Effective Dates -->
      <mat-form-field appearance="outline">
        <mat-label>Effective Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="effective_StartDate"
          (keydown)="onKeydown($event)" (blur)="dateformat($event)" />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        <mat-error *ngIf="priceMatrixForm.get('effective_StartDate')?.hasError('required')">Start Date is
          required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Effective End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="effective_EndDate" (keydown)="onKeydown($event)"
          (blur)="dateformat($event)" />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Rebate UOM and value -->
      <mat-form-field appearance="outline">
        <mat-label>Rebate UOM</mat-label>
        <mat-select formControlName="rebate_UOM">
          <mat-option *ngFor="let o of rebateUOM()" [value]="o.id">{{ o.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Rebate Value</mat-label>
        <input matInput type="text" data-testId="rebateValue" formControlName="rebateValue"
          (input)="roundOff($event, 9999, 4, 0, 'rebateValue')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- EIS Fuel surcharge -->
      <mat-form-field appearance="outline"
        [class.validation-field]="priceMatrixForm.get('eIS')?.invalid && (priceMatrixForm.get('eIS')?.dirty || priceMatrixForm.get('eIS')?.touched)">
        <mat-label>EIS(%)</mat-label>
        <input matInput type="text" data-testId="eIS" formControlName="eIS"
          (input)="roundOff($event, 100, 2, 0, 'eIS')" />
        @if (priceMatrixForm.get('eIS')?.hasError('max')) {
          <mat-error>Value cannot be greater than 100</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline"
        [class.validation-field]="priceMatrixForm.get('fuelSurcharge')?.invalid && (priceMatrixForm.get('fuelSurcharge')?.dirty || priceMatrixForm.get('fuelSurcharge')?.touched)">
        <mat-label>Fuel Surcharge(%)</mat-label>
        <input matInput type="text" data-testId="fuelSurcharge" formControlName="fuelSurcharge"
          (input)="roundOff($event, 100, 2, 0, 'fuelSurcharge')" />
        @if (priceMatrixForm.get('fuelSurcharge')?.hasError('max')) {
        <mat-error>Value cannot be greater than 100</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row cols-3">
      <!-- Minumum Load Fee, Emergency -->
      <mat-form-field appearance="outline">
        <mat-label>Minimum Load Fee</mat-label>
        <input matInput type="text" data-testId="minimalLoadFee" formControlName="minimalLoadFee"
          (input)="roundOff($event, 9999, 4, 0, 'minimalLoadFee')" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Emergency Fee</mat-label>
        <input matInput type="text" data-testId="emergency" formControlName="emergency"
          (input)="roundOff($event, 9999, 4, 0, 'emergency')" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Unloading Fee</mat-label>
        <input matInput type="text" data-testId="unloadFee" formControlName="unloadFee"
          (input)="roundOff($event, 9999, 4, 0, 'unloadFee')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      @if(showBinRentalFee()){
        <mat-form-field appearance="outline">
          <mat-label>Bin Rental Fee</mat-label>
          <input matInput type="text" data-testId="binRentalFee" formControlName="binRentalFee"
            (input)="roundOff($event, 9999, 4, 0, 'binRentalFee')" />
        </mat-form-field>
      }
      <!-- No Show, Partial Load to yard -->
      <mat-form-field appearance="outline">
        <mat-label>No Show Fee</mat-label>
        <input matInput type="text" data-testId="noShow" formControlName="noShow"
          (input)="roundOff($event, 9999, 4, 0, 'noShow')" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Partial Load to Yard Fee</mat-label>
        <input matInput type="text" data-testId="partialLoadToYard" formControlName="partialLoadToYard"
          (input)="roundOff($event, 9999, 4, 0, 'partialLoadToYard')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Environmental Fees -->
      <mat-form-field appearance="outline">
        <mat-label>LTL Environment Fee</mat-label>
        <input matInput type="text" data-testId="environmentalFee_LTL" formControlName="environmentalFee_LTL"
          (input)="roundOff($event, 9999, 4, 0, 'environmentalFee_LTL')" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>FTL Environment Fee</mat-label>
        <input matInput type="text" data-testId="environmentalFee_FTL" formControlName="environmentalFee_FTL"
          (input)="roundOff($event, 9999, 4, 0, 'environmentalFee_FTL')" />
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Package Type, Haulers -->
      <mat-form-field appearance="outline">
        <mat-label>Package Type</mat-label>
        <mat-select formControlName="packageType">
          <mat-option *ngFor="let p of packageTypes()" [value]="p.id">{{ p.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <app-select-search (selectedItemId)="onHaulerReceived($event)" [selectItems]="selectHaulerItems" selectTitle = "Hauler"
        formControlName="hid"></app-select-search>
    </div>
    <div class="form-grid-row">
      <!-- unload fee and is self haul -->
      <mat-slide-toggle formControlName="selfHaul" color="primary" >
        <span class="font-medium text-gray-700 w-64 inline-block">Self Haul </span>
      </mat-slide-toggle>

      <!-- Commission Eligible and Invoice N/a -->
      <mat-slide-toggle formControlName="commissionEligible" color="primary" >
        <span class="font-medium text-gray-700 w-64 inline-block">Commission Eligible</span>
      </mat-slide-toggle>

    </div>
    <div class="form-grid-row">
      <mat-slide-toggle formControlName="incurEstimatedProcessingCosts" color="primary" >
        <span class="font-medium text-gray-700 w-64 inline-block">No Estimated Processing Costs</span>
      </mat-slide-toggle>
      <mat-slide-toggle formControlName="fuelSurchargePassThrough" color="primary" >
        <span class="font-medium text-gray-700 w-64 inline-block">Fuel Surcharge Fee Pass Through</span>
      </mat-slide-toggle>
    </div>
    <div class="form-grid-row">
      <mat-slide-toggle formControlName="invoiceNA" color="primary" >
        <span class="font-medium text-gray-700 w-64 inline-block">Invoice N/A</span>
      </mat-slide-toggle>
      <mat-slide-toggle formControlName="haulFeePassThrough" color="primary" >
        <span class="font-medium text-gray-700 w-64 inline-block">Haul Fee Pass Through</span>
      </mat-slide-toggle>
    </div>
    <div class="form-grid-row">
      <div class="toggle-group-wrapper">
        <mat-slide-toggle formControlName="isReviewed" color="primary" >
          <span class="font-medium text-gray-700 w-44 inline-block">Is Reviewed</span>
        </mat-slide-toggle>

        <div class="reviewer-subtext" *ngIf="isEditMode() && priceMatrixForm.get('isReviewed')?.value">
          <div class="reviewer-name">{{ priceMatrixForm.get('reviewedBy')?.value }}</div>
          <div class="reviewer-date">{{ priceMatrixForm.get('reviewedDate')?.value | date: 'M/d/yyyy, h:mm:ss a' }}
          </div>
        </div>
      </div>
    </div>
    <div class="add-salesrep-button-container">
      @if (showSalesRepAddButton()) {
      <button mat-raised-button color="primary" (click)="addorEditSalesRep(null, true)" type="button">
        <mat-icon>add</mat-icon> Add Sales Rep
      </button>
      }
    </div>
  </form>
  <div class="gridheight mat-elevation-z8 viewport">
    <table mat-table [dataSource]="addtPmSalesRep" class="mat-elevation-z8" multiTemplateDataRows>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions</th>
        <td mat-cell *matCellDef="let row">
          <div>
            @if(showSalesRepGridEditButton()) {
            <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit"
              (click)="addorEditSalesRep(row, false)" [disabled]="row.id === 0">
              <mat-icon>edit</mat-icon>
            </button>
            }
            @if(showSalesRepGridDeleteButton()) {
            <button mat-icon-button type="button" color="warn" title="Delete" style="color: red;"
              (click)="deleteSalesRep(row.id, row)">
              <mat-icon>delete</mat-icon>
            </button>
            }
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="salesRepName">
        <th mat-header-cell *matHeaderCellDef> Sales<br />Rep Name </th>
        <td mat-cell *matCellDef="let element"> {{element.salesRepName}} </td>
      </ng-container>
      <ng-container matColumnDef="effectiveStartDate">
        <th mat-header-cell *matHeaderCellDef> Start Date </th>
        <td mat-cell *matCellDef="let element"> {{element.effectiveStartDate | date : "MM/dd/yyyy"}} </td>
      </ng-container>
      <ng-container matColumnDef="effectiveEndDate">
        <th mat-header-cell *matHeaderCellDef> End Date </th>
        <td mat-cell *matCellDef="let element"> {{element.effectiveEndDate | date : "MM/dd/yyyy"}} </td>
      </ng-container>
      <ng-container matColumnDef="commEligible">
        <th mat-header-cell *matHeaderCellDef> Comm<br />Eligible </th>
        <td mat-cell *matCellDef="let element"> {{element.commEligible ? 'Yes' : 'No'}} </td>
      </ng-container>
      <ng-container matColumnDef="percentage">
        <th mat-header-cell *matHeaderCellDef> Percentage </th>
        <td mat-cell *matCellDef="let element"> {{element.percentage}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedPMSalesRepColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedPMSalesRepColumns;"></tr>

      <!-- Row shown when there is no data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center p-4 italic text-gray-500" [attr.colspan]="displayedPMSalesRepColumns.length"
          style="color: red;text-align: center;font-weight: 500;">
          No Sales Reps.
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" (click)="cancel()">Cancel</button>
  @if(canSave){
    <button mat-raised-button color="primary" (click)="save()">Save</button>
  }
</mat-dialog-actions>